import styled from '@emotion/styled';
import { AlertModal } from 'components/AlertModal';
import defaultImage from 'images/splash-default.jpg';
import React, { ReactNode } from 'react';
import tw from 'twin.macro';

interface LayoutProps {
  children: ReactNode;
}

const Container = styled.div`
  ${tw`flex items-center justify-center h-screen overflow-hidden bg-s-neutral-subdued-light lg:justify-start lg:px-28`};
`;

const ImageContainer = styled.div`
  ${tw`absolute inset-0`};
  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
`;

function Component(props: LayoutProps) {
  const { children } = props;

  return (
    <React.Fragment>
      <Container>
        <ImageContainer>
          <img alt="afternoon" src={defaultImage} />
        </ImageContainer>
        {children}
      </Container>
      <AlertModal />
    </React.Fragment>
  );
}

export const Layout = Component;
